import { download_json } from "../utills/utills";
import { base_url } from "./baseURL";

export interface ILicenseForm {
  api_key: string;
  device_key: string;
  store_id: string;
  device_type: "Android" | "Windows";
  expire_date: string;
}

export const make_license = async ({
  api_key,
  device_key,
  expire_date,
  store_id,
  device_type,
}: ILicenseForm) => {
  const response = await fetch(`${base_url()}/license/make_license`, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      key: api_key,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      device_key,
      expire_date,
      store_id,
      device_type,
    }),
  });
  const json = await response.json();
  const contentType = response.headers.get('Content-Type')
  if (response.ok) {
    return download_json(json, store_id, contentType);
  } else {
    switch (response.status) {
      case 400:
        return alert("Bad request");
      case 401:
        return alert("Please Check your Auth_key or form you submit");
      case 404:
        return alert("Please Check fetch URL or Params");
      case 500:
        return alert("Inform internal server error to your advisor");
      default: {
        console.log(`Response Error : ${response.status} error`);
        return alert(`${response.status} is ocurred. check!!`);
      }
    }
  }
};

/// downloads


export const download_file = async (file_type: string, file_name: string) => {
  const anchor = document.createElement("a");
  const url = `${base_url()}/file/download_request?file_type=${file_type}`;
  // const res = await fetch(
  //   `${base_url()}/file/download?file_type=${file_type}`,
  //   {
  //     method: "GET",
  //     headers: {
  //       "Access-Control-Allow-Origin": "*",
  //     },
  //   }
  // );
  // const file_name = res.headers.get("File-Name");
  // const content_type = res.headers.get("Content-Type");

  // const URL = await res.arrayBuffer().then((buffer) => {
  //   const blob = new Blob([buffer], {
  //     type: content_type || "application/zip",
  //   });
  //   return window.URL.createObjectURL(blob);
  // });
  anchor.href = url;
  anchor.download = `${file_name}.zip`;
  anchor.click();
};

export const downloadGuideFile = async () => {
  const anchor = document.createElement("a");
  const url = `${base_url()}/file/download_request?file_type=Guide`;
  // const res = await fetch(url, {
  //   method: "GET",
  //   headers: {
  //     "Access-Control-Allow-Origin": "*",
  //   },
  // });
  // const file_name = res.headers.get("File-Name");
  // const content_type = res.headers.get("Content-Type");
  // const URL = await res.arrayBuffer().then((buffer) => {
  //   const blob = new Blob([buffer], {
  //     type: content_type || "application/pdf",
  //   });
  //   return window.URL.createObjectURL(blob);
  // });
  anchor.href = url;
  anchor.download = `Guide.pdf`;
  anchor.click();
};